import React, { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { logout, sessionRestored } from '@/store/authSlice';
import { restoreAuthenticationSession } from '../services/authSession';

interface AuthBootstrapProps {
  children: ReactNode;
}

const AuthBootstrap: React.FC<AuthBootstrapProps> = ({ children }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.auth.status);

  useEffect(() => {
    let active = true;

    void restoreAuthenticationSession().then((session) => {
      if (!active) return;
      dispatch(session ? sessionRestored(session) : logout());
    });

    return () => {
      active = false;
    };
  }, [dispatch]);

  if (status === 'checking') {
    return (
      <div className="auth-bootstrap" role="status" aria-live="polite">
        <span className="auth-bootstrap-spinner" aria-hidden="true" />
        <span>{t('auth.restoring_session')}</span>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthBootstrap;
